import React, { useEffect } from "react"; 

import { useStoreDispatch, useStoreSelector } from "../../store/store";
import { chainId } from "../../settings";



const ProviderChangesHandler: React.FC = () => {
    const { provider } = useStoreSelector(store => store.app);
    const { disconnectApp } = useStoreDispatch();

    useEffect( () => {
        if (provider && provider.on) {
            provider.on('chainChanged', (chain_id: string) => {
                if (chain_id !== chainId)
                    disconnectApp();
            });
            provider.on('accountsChanged', () => {
                window.location.reload();
            });
            provider.on("disconnect", disconnectApp);
        }

        return() => {
            if (provider && provider.removeListener) {
                provider.removeListener('accountsChanged', disconnectApp);
                provider.removeListener('chainChanged', (chain_id: string) => {
                    if (chainId !== chain_id)
                        disconnectApp();
                });
            }
        }
    // eslint-disable-next-line
    }, [provider])

    return null
}


export default ProviderChangesHandler;